// @flow

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';
import { Spinner } from 'component-library';
import NewsItem from './NewsItem/NewsItem.js';
import { getPlayerNews } from '../../../../redux/actions/playerNews';
import './../PlayerCard.css';
import './News.css';

// header

type Props = {
    cookies: { [key: string]: any },
    player: { [key: string]: any },
    playerNews: { [key: string]: any },
    getPlayerNews: Function
};

type State = {
    loginCookie: string
};

class News extends Component<Props, State> {
    constructor(props) {
        super(props);
        const { cookies } = this.props;
        this.state = {
            loginCookie: cookies.get('flid') || '0'
        };
    }
    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };

    componentDidMount() {
        if (this.props.player !== null) {
            this.props.getPlayerNews(this.props.player.player_id, this.state.loginCookie);
        }
    }

    render() {
        const newsHeader = <div className={'modal-subheader'}>Player News</div>;
        let newsDetail = <Spinner />;
        if (this.props.playerNews.isLoading === false) {
            if (this.props.playerNews.results['0']) {
                const playerNewsArray = this.props.playerNews.results['0'];
                const playerNewsLen = playerNewsArray.length;
                if (playerNewsLen > 0) {
                    newsDetail = (
                        <div className={'news-container styled-scrollbar'}>
                            {playerNewsArray.map(function(n) {
                                return <NewsItem key={n.id} newsItem={n} />;
                            })}
                        </div>
                    );
                } else {
                    newsDetail = <div className={'news-container'}>No recent news for this player.</div>;
                }
            }
        }
        return (
            <React.Fragment>
                {newsHeader}
                {newsDetail}
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        playerNews: state.playerNews
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getPlayerNews: playerId => dispatch(getPlayerNews(playerId))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withCookies(News));



// WEBPACK FOOTER //
// ./src/components/Main/PlayerCard/News/News.js